module.exports = __webpack_public_path__ + "static/show_tasks_that_have_no_due_date-3e3f01ae1a534fc8dd17b5f9b3a2b01f.png";